import { ErrorHandler, RequestOptions } from '../common/models/GenericTypes';
import { SavedSearch } from '../common/models/SavedSearches';
import { Delete, Get, Post, Put } from '../util/HttpUtils';

export async function GetSavedSearchById(ssid: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    errorHandler,
  };

  return Get<SavedSearch>(`api/SavedSearches/${ssid}`, options);
}

export async function DeleteSavedSearch(id: number, errorHandler?: ErrorHandler) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Delete<boolean>(`api/SavedSearches/${id}`, options);
}

export async function UpdateSavedSearch(
  id: number,
  name: string,
  freq: number,
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  const data: Partial<SavedSearch> = {
    id: id,
    name: name,
    autoRunFrequency: freq,
  };

  return Put<boolean>(`api/SavedSearches/${id}`, options, data);
}

export async function CopySavedSearch(
  id: number,
  name: string,
  userIds: number[],
  errorHandler?: ErrorHandler
) {
  const options: RequestOptions = {
    noDataReturned: true,
    errorHandler,
  };

  return Post<boolean>(
    `api/SavedSearches/${id}?name=${encodeURIComponent(name)}`,
    options,
    userIds
  );
}
